import { User } from '@time-line/components/icons';
import type { Nav } from '@time-line/components/types';
import {
  ABOUT_NAV,
  HCP,
  LONGEVITY_GAME,
  SKINCARE_BUILD_YOUR_ROUTINE_NAV,
  SKINCARE_EXPLORE_NAV,
  SKINCARE_SCIENCE,
} from 'lib/constants/navigation';
import { ACCOUNT } from 'lib/constants/routes';
import { signIn } from 'next-auth/react';

export interface MenuData {
  supplements: {
    nav: Nav;
  };
  skincare: {
    nav: Nav;
  };
}

const secondary = [
  {
    label: 'Account',
    icon: <User boxSize="sm" />,
    name: 'account',
    onClick: () =>
      signIn('shopify', {
        callbackUrl: `${ACCOUNT}?login=success`,
      }),
  },
];

export const MENU_DATA: MenuData = {
  supplements: {
    nav: {
      primary: [ABOUT_NAV, LONGEVITY_GAME, HCP],
      secondary,
    },
  },
  skincare: {
    nav: {
      primary: [SKINCARE_SCIENCE, SKINCARE_EXPLORE_NAV],
      cta: SKINCARE_BUILD_YOUR_ROUTINE_NAV,
      secondary,
    },
  },
};

export const RESPONSIVE_BP = 'lg';
export const NAV_ROW_HEIGHT_WITH_TOGGLE = '32px';
export const MOBILE_MENU_ID = 'mobile-menu';
